let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lBg7Z")).then(() => parcelRequire('lO2Ki'));